define('ticketingService/ticketingService',['require','exports','module','jquery','deepObject/get','ensureArray/ensureArray','ensureDate/ensureDate','events/paperboy','formatDate/formatDate'],function(require, exports, module) {

    var $   = require('jquery');
    var deep = require('deepObject/get');
    var ensureArray = require('ensureArray/ensureArray');
    var ensureDate = require('ensureDate/ensureDate');
    var events = require('events/paperboy').mixin;
    var formatDate = require('formatDate/formatDate');

    var sSaleDate = /^(\d{4})(\d{2})(\d{2})/,
        rSaleDate = '$1/$2/$3';

    var options = {};
    var POLL_INTERVAL = 10 * 10000;

    function Tickets(opts){
        this.options = $.extend({
            i18n: 'en'
        }, opts);

        this.trigger =  events(this, ['loadSuccess']);

        this.timer;
    }

    Tickets.prototype = {

        load : function(){
            var date = ensureDate(this.options.date);
            var ymd = formatDate.toYMD(date);
            var self = this;
            return $.ajax({
                url: '/ticketing-client/json/Game.tiksrv',
                dataType: 'text',
                //cache:    !bam.env.host.isDev, // bust cache on dev
                data: {
                    sport_id: 1,
                    site_section: '\'DEFAULT\'',
                    ticket_category: '\'TICKETS\'',
                    begin_date: ymd,
                    end_date: ymd,
                    year: date.getFullYear()
                },
                dataFilter: function(data) {
                    var games = ensureArray(deep($.parseJSON(data), 'events.game'));

                    var map = $.map(games, function(game) {
                        var link = game.ticket_link;
                        link.game_pk = game.schedule_id;
                        link.schedule_id = game.schedule_id;
                        link.away_or_home = link.team_id === game.home_team_id && 'home' || link.team_id === game.away_team_id && 'away';
                        link.on_sale_start_date = link.on_sale_start_date && link.on_sale_start_date.replace(sSaleDate, rSaleDate);
                        link.on_sale_end_date = link.on_sale_end_date && link.on_sale_end_date.replace(sSaleDate, rSaleDate);
                        return link;
                    });

                    self.trigger('loadSuccess', map);
                    return map;
                }
            });
        },

        start : function(){
            var self = this;

            function update(){
                self.load();
                self.start();
            }

            this.timer = setTimeout(update,POLL_INTERVAL);
        },

        stop : function(){
            clearTimeout(this.timer);
            delete this.timer;
        }
    };

    return Tickets;

});

